import styled from 'vue-styled-components'
import { breakpointStyle } from '../../utils'

const StyledPage = styled.div`
  
`

const StyledContainer = styled.div`
  
`

const StyledContent = styled.div`
  flex-grow: 1;
  background-color: ${props => props.theme.colors.background};
  padding: 32px 20px 26px;
  
  ${props => breakpointStyle(props.theme.media.mobileS, `
    padding-left: 30px;
    padding-right: 30px;
  `)}
  
  ${props => breakpointStyle(props.theme.media.desktop, `
    padding-left: 0;
  `)}
`

const propsRow = {
  full: Boolean,
  marginBottom: String
}

const StyledRow = styled('div', propsRow)`
  margin-bottom: ${props => props.marginBottom};
  ${props => breakpointStyle(props.theme.media.desktop, `
    padding-left: ${props.full ? '83px' : '24%'}
  `)}
`

export {
  StyledPage,
  StyledContainer,
  StyledContent,
  StyledRow
}



// WEBPACK FOOTER //
// ./src/components/Layouts/StyledLayouts.js